import { Toaster } from "@safers/ui/molecules";
import { useStompEvents, useAutoPushSubscribe } from "./hooks";
import { AppRoutes } from "./routes";
import { EventAlarmBanner } from "./components/EventAlarmBanner";
import {
  useToastStore,
  selectToasts,
  selectDismissToast,
  useCommandModalStore,
  selectCommandModalOpen,
  selectOpenCommandModal,
  selectCloseCommandModal,
} from "./stores";
import { CommandModal } from "./components/CommandModal";
import { InstallBanner } from "./components/InstallBanner";
import { useEffect } from "react";

export function App() {
  useStompEvents();
  useAutoPushSubscribe();
  const toasts = useToastStore(selectToasts);
  const dismissToast = useToastStore(selectDismissToast);
  const commandOpen = useCommandModalStore(selectCommandModalOpen);
  const openCommand = useCommandModalStore(selectOpenCommandModal);
  const closeCommand = useCommandModalStore(selectCloseCommandModal);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.ctrlKey && event.code === "KeyK") {
        event.preventDefault();
        openCommand();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [openCommand]);

  return (
    <>
      <AppRoutes />
      <EventAlarmBanner />
      <CommandModal open={commandOpen} onClose={closeCommand} />
      <InstallBanner />
      <Toaster toasts={toasts} onDismiss={dismissToast} position="bottom-right" />
    </>
  );
}
